import actionCreatorFactory from "typescript-fsa";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Employee } from "../types/types";
import { RootState } from "./index.store";

export interface AppState {
  isOnline: any;
}

export const appInitialState: AppState = {
  isOnline: true,
};

const actionCreator = actionCreatorFactory("app");
export const appActions = {
  USER_CLICKED_LOGOUT_BUTTON: actionCreator("USER_CLICKED_LOGOUT_BUTTON"),
  REDUCER_SET_IS_ONLINE: actionCreator<any>("REDUCER_SET_IS_ONLINE"),
  REDUCER_SET_LOGIN_USER: actionCreator<Employee>("REDUCER_SET_LOGIN_USER"),
};

export const appStateSelector = (state: RootState) => state.app;
const s = appStateSelector;
export const isOnlineSelector = (state: RootState) => s(state).isOnline;

export const appReducer = reducerWithInitialState<any>(appInitialState).case(
  appActions.REDUCER_SET_IS_ONLINE,
  (state, payload) => ({
    ...state,
    isOnline: payload,
  })
);
